import { useMapSlice } from 'app/containers/Map/slice';
import { IFieldProgress, ITask } from 'app/containers/Task/slice/types';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

const useSetInitialEditTaskFields = ({ task }: { task?: ITask }) => {
  const dispatch = useDispatch();
  const mapActions = useMapSlice().actions;

  // Set initial task fields
  useEffect(() => {
    if (task) {
      const fields =
        task.fieldTasks?.map(fieldTask => fieldTask.fieldSeason.id) || [];

      dispatch(mapActions.setSelectedPolygonsIds(fields));

      const fieldsProgress: IFieldProgress[] =
        task.fieldTasks?.map(
          ({ fieldSeason: { id: fieldId, area }, id, progress }) => ({
            fieldTaskId: id,
            fieldId,
            progress,
            area,
          }),
        ) || [];

      dispatch(mapActions.setFieldsProgress(fieldsProgress));
    }
  }, [task, mapActions, dispatch]);
  return null;
};

export default useSetInitialEditTaskFields;
